import * as React from 'react';
import { Link } from 'react-router-dom';
import { Category } from '../product';

export interface CategoryListItemProps {
  category: Category;
}

export default function CategoryListItem(props: CategoryListItemProps) {
  return (
    <div className="flex justify-stretch items-center pv2 bb b--black-10">
      <div className="mr4">
        <img className="w3 h3 br-100" src={props.category.image_url} alt="" />
      </div>
      <div className="flex-auto w-third">
        <h4 className="lh-title ma0 mb2">{props.category.name}</h4>
      </div>
      <div className="flex-auto w-third">
        <p className="lh-copy ma0 f6 black-50">
          {props.category.description_text}
        </p>
      </div>
      <div className="w-30 tr">
        {props.category.parent_id && (
          <Link
            to={{
              pathname: `/categories/${props.category.parent_id}`,
            }}
            className="link black underline b mh3"
          >
            Parent Category
          </Link>
        )}
        <Link
          to={{
            pathname: `/categories/${props.category.id}`,
            state: {
              category: props.category,
            },
          }}
          className="link black underline b mh3"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}
